import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import Grid from "../../lib/components/grid";

import { GridColumns } from "./templatesMasterSetup";
import { Row } from "react-data-grid";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      width: "100%",
    },
    blackRow: {
      color: "black",
    },
    redRow: {
      color: "red",
    },
    boldRow: {
      fontWeight: "bold",
    },
    toolbarContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginTop: "20px",
      marginBottom: "-60px"
    },
  });

type TemplatesMasterProps = {
  maintenancemode: boolean;
  templateData: Array<any>;
  handleRemoveTemplate: (id) => void;
  handleEditTemplate: (row) => void;
  handleMasterClick: (row) => void;
} & WithStyles<typeof styles>;

export class TemplatesMasterUnstyled extends React.Component<TemplatesMasterProps, any> {
  state = {
    classes: undefined,
    templateData: [],
    handleRemoveTemplate: undefined,
    handleEditTemplate: undefined,
    handleMasterClick: undefined,
    maintenancemode: false,
    loading: false,
    selectedRow: null,
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;
    this.state.handleRemoveTemplate = props.handleRemoveTemplate;
    this.state.handleEditTemplate = props.handleEditTemplate;
    this.state.handleMasterClick = props.handleMasterClick;
    this.state.maintenancemode = props.maintenancemode;
  }

  handleSelectedRowChange = (selectedRow: any) => {
    this.setState({ selectedRow });
    this.state.handleMasterClick(selectedRow);
  };

  customRowRenderer = (props, classes) => {
    const { row } = props;
    const fontWeight = this.state.selectedRow && this.state.selectedRow.id === row.id && classes.boldRow

    return (
      <Row
        {...props}
        onDoubleClick={() => this.handleSelectedRowChange(row)}
        className={fontWeight}
      />
    );
  };

  getGridColumns = (data, filters, columnArrangement, columnsWidth) => {
    return GridColumns(
      this.state.maintenancemode,
      this.state.handleRemoveTemplate,
      this.state.handleEditTemplate,
      data,
      filters,
      columnArrangement,
      columnsWidth
    );
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <Grid
          fill
          data={this.props.templateData}
          loading={this.state.loading}
          GridColumns={this.getGridColumns}
          clearFilters={"templatesMaster"}
          showFilterChips={true}
          rowRenderer={(props) => this.customRowRenderer(props, classes)}
          toolbarChildren={
            <div className={classes.toolbarContainer}>
              {this.state.maintenancemode && (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ margin: "2px", marginBottom: "10px" }}
                  onClick={() => this.props.handleEditTemplate({})}
                >
                  Add Template
                </Button>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

export default withStyles(styles)(TemplatesMasterUnstyled);